



































































































































































































import Vue from 'vue';
import { PaymentType } from '@/common/types/payments.types';
import { Transaction, TransactionStatus } from '@/common/types/transactions.types';
import { mapGetters } from 'vuex';

export default Vue.extend({
  props: {
    transaction: {
      type: Object as () => Transaction,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['isSurchargingEnabled']),
    hasRefunds(): boolean {
      return (this.transaction!.totalRefundedAmount || 0) > 0;
    },
    hasBillingAddress(): boolean {
      return (
        this.transaction !== null
        && this.transaction.customerDetails !== null
        && this.transaction.customerDetails?.billingAddress !== null
        && this.transaction.customerDetails?.billingAddress !== undefined
      );
    },
    hasShippingAddress(): boolean {
      return (
        this.transaction !== null
        && this.transaction.customerDetails !== null
        && this.transaction.customerDetails?.shippingAddress !== null
        && this.transaction.customerDetails?.shippingAddress !== undefined
      );
    },
    usedAToken(): string {
      if (typeof this.transaction.usedAToken !== 'undefined') {
        return this.transaction.usedAToken ? 'Yes' : 'No';
      }
      return '';
    },
    expirationDate(): string {
      if (this.transaction!.paymentMethod!.type !== PaymentType.CREDIT) {
        return '';
      }

      const { expMonth: month, expYear: year } = this.transaction!.paymentMethod!.creditCard!;
      return `Exp: ${month}/${year}`;
    },
    transactionTypeIcon(): string {
      if (this.transaction!.paymentMethod!.type === PaymentType.CASH) {
        return 'money-bill-alt';
      }
      if (this.transaction!.paymentMethod!.type === PaymentType.ACH || this.transaction!.paymentMethod!.type === PaymentType.KEYBANK) {
        return 'money-check';
      }
      if (this.transaction!.cardType! !== '') {
        return this.transaction!.cardType!;
      }
      return 'credit-card';
    },
    isCustomerInVault(): boolean {
      const customerDetails = this.transaction?.customerDetails;
      return customerDetails !== undefined && customerDetails !== null && customerDetails.inVault;
    },
    isForSubscription(): boolean {
      const subscriptionId = this.transaction?.subscriptionId;
      return subscriptionId !== undefined && subscriptionId !== null && subscriptionId !== '';
    },
    transactionType(): string {
      if (this.transaction!.paymentMethod!.type === PaymentType.CASH) {
        return 'Cash';
      }
      if (this.transaction!.paymentMethod!.type === PaymentType.ACH) {
        return 'ACH';
      }
      if (this.transaction!.paymentMethod!.type === PaymentType.KEYBANK) {
        return 'Keybank ACH';
      }
      return 'Credit';
    },
    statusColor(): string {
      switch (this.transaction!.status) {
        case TransactionStatus.DECLINED:
          return 'tw-text-red-600';
        default:
          return '';
      }
    },
    isDeclined(): boolean {
      return this.transaction!.status === TransactionStatus.DECLINED;
    },
    isSurchargeTransaction(): boolean {
      const transactionType: string = (this.transactionType as string).toLowerCase();
      return this.transaction.surchargeAmount !== 0 && transactionType === PaymentType.CREDIT;
    },
    isNonCashAdjustmentTransaction(): boolean {
      if (this.transaction.transactionSource) {
        return true;
      } return false;
    },
    hasBatchLink(): boolean {
      const batchId = this.transaction?.batchId;
      if (batchId) {
        const route = this.$route;
        if (route.name === 'merchant.batches.view' && route.params?.id === batchId) {
          return false;
        }
      }
      return !!batchId;
    },
    formattedBatchLabel() {
      const value = this.transaction?.batch;
      return value ? `Batch #${value}` : 'Batch';
    },
    formattedHppLinkLabel() {
      const hpp: { slug?: string; name?: string; } | undefined = this.transaction?.hostedPaymentPage;
      return hpp?.slug || hpp?.name || 'HPP';
    },
    visibleEnhancedFields(): any[] {
      return (this.transaction.enhancedFields as [])
        .filter((item:any) => item.name !== 'tax_id');
    },
  },
});
